import * as React from "react";

import { PlpSelectedFacetOption } from "../../model";

import { useProductListController_forFiltering } from "../product-list-provider";

interface PlpPresenterForTheFilterMenu_AnyBreakpointConsumerInterface {
  handleRemoveSelectedFilterOption: (
    selectedOption: PlpSelectedFacetOption
  ) => void;
  handleRemoveAllSelectedOptions: () => void;
}

const defaultValue = {};

const PlpPresenterForTheFilterMenu_AnyBreakpointContext = React.createContext(
  defaultValue as PlpPresenterForTheFilterMenu_AnyBreakpointConsumerInterface
);

export const PlpPresenterForTheFilterMenu_AnyBreakpointProvider: React.FunctionComponent =
  (props) => {
    const {
      handleRemoveSelectedFilterOption:
        productListController_forFiltering_handleRemoveSelectedFilterOption,
      handleRemoveAllSelectedOptions:
        productListController_forFiltering_handleRemoveAllSelectedOptions,
    } = useProductListController_forFiltering();

    const handleRemoveSelectedFilterOption = React.useCallback(
      (selectedOption: PlpSelectedFacetOption) => {
        productListController_forFiltering_handleRemoveSelectedFilterOption(
          selectedOption
        );
      },
      [productListController_forFiltering_handleRemoveSelectedFilterOption]
    );

    const handleRemoveAllSelectedOptions = React.useCallback(() => {
      productListController_forFiltering_handleRemoveAllSelectedOptions();
    }, [productListController_forFiltering_handleRemoveAllSelectedOptions]);

    const value: PlpPresenterForTheFilterMenu_AnyBreakpointConsumerInterface =
      React.useMemo(
        () => ({
          handleRemoveSelectedFilterOption,
          handleRemoveAllSelectedOptions,
        }),
        [handleRemoveSelectedFilterOption, handleRemoveAllSelectedOptions]
      );
    return (
      <PlpPresenterForTheFilterMenu_AnyBreakpointContext.Provider value={value}>
        {props.children || []}
      </PlpPresenterForTheFilterMenu_AnyBreakpointContext.Provider>
    );
  };

export const usePlpPresenterForTheFilterMenu_AnyBreakpoint = () => {
  const context = React.useContext(
    PlpPresenterForTheFilterMenu_AnyBreakpointContext
  );
  if (context === defaultValue) {
    throw new Error(
      "usePlpPresenterForTheFilterMenu_AnyBreakpoint must be used within a PlpPresenterForTheFilterMenu_AnyBreakpointProvider"
    );
  }
  return context;
};
